import React, { FC, Fragment } from 'react';
import { some } from 'lodash';

import {
  ReactionType,
  useAddReactionAnalyticsMutation,
  useCreateReactionMutation,
  useDeleteReactionMutation,
} from 'api';
import { Heart } from 'components';
import { useContent, useCurrentUser } from 'hooks';
import { useReactions } from 'features/content/updaters';

const Reactions: FC = () => {
  const content = useContent();
  const currentUser = useCurrentUser();

  const createMutationOptions = useReactions('create');
  const { mutate: createReaction } = useCreateReactionMutation(createMutationOptions);

  const deleteMutationOptions = useReactions('remove');
  const { mutate: deleteReaction } = useDeleteReactionMutation(deleteMutationOptions);

  const { mutate: addReactionAnalytics } = useAddReactionAnalyticsMutation();

  const { content_id, reacted_by } = content;
  const isLiked = some(reacted_by, { id: currentUser.id });

  function handleClick() {
    const mutation = isLiked ? deleteReaction : createReaction;
    mutation({ content_id, reaction_type: ReactionType.Like });

    return addReactionAnalytics({ content_id, reaction_type: ReactionType.Like });
  }

  function renderReactions() {
    return <Heart active={isLiked} onClick={handleClick} />;
  }

  return <Fragment>{renderReactions()}</Fragment>;
};

export default Reactions;
